import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Search from '@/views/Search'
import Action from '@/views/Action'
import Ie from '@/views/Ie'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/plan',
      name: 'plan',
      component: Home
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/advanced-search',
      name: 'advanced search',
      component: Search,
      meta: { advanced: true }
    },
    {
      path: '/action/:id/:fase',
      name: 'action',
      component: Action,
      children: [
        {
          path: 'characterization',
          name: 'characterization',
          component: Action
        },
        {
          path: 'indicators',
          name: 'indicators',
          component: Action
        }
      ]
    },
    {
      path: '/ie',
      name: 'ie',
      component: Ie
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return to.name === 'Plan' ? false : { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js